import { render, staticRenderFns } from "./PackageServiceLogs.vue?vue&type=template&id=c20d8034&scoped=true&"
import script from "./PackageServiceLogs.vue?vue&type=script&lang=js&"
export * from "./PackageServiceLogs.vue?vue&type=script&lang=js&"
import style0 from "./PackageServiceLogs.vue?vue&type=style&index=0&id=c20d8034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20d8034",
  null
  
)

export default component.exports